import React, { Component, PropTypes } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import * as modalActions from 'pluton-core/lib/actions/modal.actions'
import { loginModel } from 'pluton-core/lib/models/auth/login.model';
import { errorModel } from 'pluton-core/lib/models/service/error.model';
import { routes } from 'pluton-core/lib/constants/routes.constant';
import { history } from '../history';


export default function (ComposedComponent, canEnterNotLoggedIn = true) {

    class Authentication extends Component {
        
        componentWillMount() {
            this.handleAuth(this.props);
        }

        componentWillUpdate(nextProps) {
            this.handleAuth(nextProps);
        }

        handleAuth(props) {
            const {
                isAuth,
                isErrors,
                route
            } = props;

            // redirect to login if no access and not logged in
            if (!canEnterNotLoggedIn && !isAuth) {
                route.path !== routes.login()
                && history.push(routes.login());
                return;
            }

            // redirect to home if for non auth and logged in
            if (canEnterNotLoggedIn && isAuth) {
                route.path !== routes.home()
                && history.push(routes.home());
                return;
            }

            // redirect to home (connect) if errors and logged in
            if (!canEnterNotLoggedIn && isAuth && isErrors) {
                !~[routes.settings(), routes.home()].indexOf(route.path)
                && history.push(routes.home());
                return;
            }

            this.props.modalActions.closeModal();
        }

        render() {
            // return null if no access and not logged in
            const { isAuth } = this.props;
            if (!isAuth && !canEnterNotLoggedIn) {
                return null;
            }

            return <ComposedComponent {...this.props} />;
        }
    }

    const mapStateToProps = (state) => {
        const errors = state.error[errorModel.MODEL_NAME];
        const isErrors = errors.isNetworkError;

        return {
            isAuth: state.auth[loginModel.MODEL_NAME].isAuth,
            isErrors
        }
    };


    const mapDispatchToProps = (apiSetHomeStatus) => (dispatch) => {
        return {
            modalActions: bindActionCreators({
                ...modalActions
            }, dispatch),
        };
    };

    return connect(mapStateToProps, mapDispatchToProps)(Authentication);
}



// WEBPACK FOOTER //
// ./app/entry/components/AuthComponent.js